define('module/flickity',[
    'jquery',
    'underscore',
    'cnf',
    'flickity',
    '_pubsub',
    'util/imgpreload'
], function($,_,Cnf, Flickity, Pubsub, ImgPreload) {
    'use strict';
    
    return function()
    {
        var oPubsub=new Pubsub();
        
        this.options={
            selector:{
                parent:'.ce-gallery',
                flickity:'.trigger-flickity',
                triggerTilewall:'trigger-tilewall',
                descriptionHolder:'.description-holder',
                pagedotsHolder:'.pagedots-holder',
                description:'.description',
                triggerReinject:'.trigger-reinject'
            },
            className:{
                expand:'expand',
                active:'transition-active',
                activeShow:'transition-active-show'
            },
            data:{
                viewport:'viewport',
                index:'index',
                autoplay:'autoplay',
                delay:'delay',
                execute:'execute',
                cnf:'cnf',
                movePagedots:'mvpagedots',
                description:'description'
            },
            cnf:{
                cellSelector:'.item',
                setGallerySize:true,
                resize:true,
                cellAlign:'left',
                contain:true,
                percentPosition:true,
                wrapAround:true,
                pageDots:true,
                prevNextButtons:false,
                adaptiveHeight:true,
                selectedAttraction:.15,
                friction:.9
            },
            cnfGallery:{
                cellSelector:'.item',
                setGallerySize:false,
                resize:false,
                percentPosition:true,
                wrapAround:true,
                pageDots:true,
                prevNextButtons:true,
                adaptiveHeight:true
            },
            cnfStory:{
                groupCells:true,
                pageDots:false,
                cellAlign:'left',
                arrowShape: { 
                    x0: 10,
                    x1: 60, y1: 50,
                    x2: 65, y2: 45,
                    x3: 20
                }
            }
        };
        
        this.init=function()
        {
            this.extendFlickity();
            this.initOptions();
            this.initEvents();
            this.initElements();
        };
        
        this.extendFlickity=function()
        {
            /**
             * overwrite Flickity.deactivate() to prevent move of elements by flickity
             */
            Flickity.prototype.deactivate = function()
            {
                if ( !this.isActive ) {
                    return;
                }
                this.element.classList.remove('flickity-enabled');
                this.element.classList.remove('flickity-rtl');
                // destroy cells
                this.cells.forEach( function( cell ) {
                    cell.destroy();
                });
                this.unselectSelectedSlide();
                this.element.removeChild( this.viewport );
                // move child elements back into element
                /**
                 * @see: thats our purpose of prototyping: prevent automatic reinject of elements
                 * 
                moveElements( this.slider.children, this.element );
                 *
                 */
                if ( this.options.accessibility ) {
                    this.element.removeAttribute('tabIndex');
                    this.element.removeEventListener( 'keydown', this );
                }
                // set flags
                this.isActive = false;
                this.emitEvent('deactivate');
            };
        };
        
        this.initOptions=function()
        {
            this.$flickity=Cnf.$app.find(this.options.selector.flickity);
            this.oFlickity={};

            //set marker disabletouchmove to false on init
            this.disableTouchmove = false;
        };
        
        this.initEvents=function()
        {
            oPubsub.on(Pubsub.RESIZE_FLICKITY,_.bind(this.resizeFlickity,this));
            oPubsub.on(Pubsub.VIEWPORT_CHANGE,_.bind(this.onViewportChange,this));
            oPubsub.on(Pubsub.RESIZE, _.bind(this.onResize,this));
            oPubsub.on(Pubsub.UPDATE_FLICKITY_BY_ID, _.bind(this.updateFlickityById, this));
            oPubsub.on(Pubsub.DESTROY_FLICKITY_BY_ID, _.bind(this.destroyFlickityById, this));
            oPubsub.on(Pubsub.FLICKITY_ADD_ELEMENT, _.bind(this.addElement, this));
        };
        
        this.initElements=function()
        {
            if(this.$flickity.length<=0) {
                return;
            }
            
            for(var i=0,y=this.$flickity.length;i<y;i++) {
                if(this.$flickity.eq(i).find(this.options.cnf.cellSelector).length<=1) {
                    continue;
                }
                
                this.setElement(this.$flickity.eq(i));
            }
        };
        
        this.setElement=function($el)
        {
            var index = $el.data(this.options.data.index);
                
                this.oFlickity[index]={
                    index:index,
                    $el:$el,
                    $reinject:$el.find(this.options.selector.triggerReinject),
                    reinject:$el.html(),
                    expanded:false,
                    viewport:[],
                    description:false,
                    onresize:false
                };
                
                //trigger flickity dependend of current viewport
                if(undefined===$el.data(this.options.data.viewport)) {
                    this.setFlickity(index);
                } else {
                    this.oFlickity[index].viewport=$el.data(this.options.data.viewport);
                    
                    switch(Cnf.viewport) {
                        case 'mobile':
                            this.setFlickity(index);
                            break;
                            
                        case 'desktop':
                        case 'tablet':
                        default:
                            break;
                    }
                }
        };

        this.addElement = function($el)
        {
            var index = $el.data('index');
            this.setElement($el);

            //workaround on throttled network
            _.delay(_.bind(this.resizeFlickity, this, index), 100);
            _.delay(_.bind(this.resizeFlickity, this, index), 1000);
        }
        
        /**
         * set flickity for given index
         * 
         * @param {type} index
         * @returns {undefined}
         */
        this.setFlickity=function(index)
        {
            //set inline cnf
            var extend={};
            if(this.oFlickity[index].$el.data(this.options.data.autoplay)===1) {
                extend.autoPlay=this.oFlickity[index].$el.data(this.options.data.delay);
                extend.pauseAutoPlayOnHover=false;
            }
            
            //set custom cnf
            var cnf;
            switch(this.oFlickity[index].$el.data(this.options.data.cnf)) {
                case 'gallery':
                    cnf=this.options.cnfGallery;
                    break;
                    
                case 'story':
                    cnf=this.options.cnfStory;
                    break;
                    
                default:
                    cnf=this.options.cnf;
                    break;
            }
            
            this.oFlickity[index].flickity=new Flickity(this.oFlickity[index].$el[0],_.extend({}, cnf, extend));
            
            //rm outdated wrapper (will be injected on change of viewport state)
            _.delay(_.bind(function(){
                this.oFlickity[index].$reinject.remove();
            }, this), 300);
            
            //add transition classname by delay to prevent initial flicker
            _.delay(_.bind(function(index){
                this.oFlickity[index].flickity.viewport.classList.add(this.options.className.active);
            },this,index),1000);
            
            //custom handler for marked links
            var anchor;
            for(var n=0,m=this.oFlickity[index].flickity.cells.length;n<m;n++) {
                anchor=$(this.oFlickity[index].flickity.cells[n].element).find('a[href^="#"]');
                
                for(var s=0,t=anchor.length;s<t;s++) {
                    if(this.oFlickity[index].flickity.customHandle===undefined) {
                        this.oFlickity[index].flickity.customHandle={};
                    }

                    anchor.eq(s).on(Cnf.click, function(ev) {ev.preventDefault();});
                    this.oFlickity[index].flickity.customHandle[n]=anchor.eq(s).attr('href');
                }
            }
            this.oFlickity[index].flickity.on('staticClick', this.onStaticClick);
            
            //set listener on tilewall
            if(true===this.oFlickity[index].$el.hasClass(this.options.selector.triggerTilewall)) {
                this.oFlickity[index].flickity.on('staticClick', _.partial(function(_this, index, event, pointer, cellElement, cellIndex) {
                    var $el=$(cellElement);

                    //break on nodata
                    if(true === $el.data('nodata')) {
                        return;
                    }

                    if(_this.oFlickity[index].expanded===true) {
                        _this.oFlickity[index].expanded=false;
                        oPubsub.trigger(Pubsub.TRIGGER_TOGGLE_TILEWALL, $el);
                        _.delay(_.bind(function(index){
                            this.oFlickity[index].flickity.resize();
                        },_this,index),600);
                    } else {
                        _this.oFlickity[index].expanded=true;
                        $el.addClass(_this.options.className.expand);
                        _this.oFlickity[index].flickity.resize();
                        $el.removeClass(_this.options.className.expand);

                        oPubsub.trigger(Pubsub.TRIGGER_TOGGLE_TILEWALL, $el);
                    }
                },this, index));
            }
            
            //mv pagedots
            if(true===this.oFlickity[index].$el.data(this.options.data.movePagedots)) {
                $(this.oFlickity[index].flickity.pageDots.holder).appendTo(this.oFlickity[index].$el.closest(this.options.selector.parent).find(this.options.selector.pagedotsHolder));
            }
            
            //calculate description
            if(true===this.oFlickity[index].$el.data(this.options.data.description)) {
                this.oFlickity[index].description=true;
                this.oFlickity[index].$description=this.oFlickity[index].$el.find(this.options.selector.description);
                this.oFlickity[index].$descriptionHolder=this.oFlickity[index].$el.closest(this.options.selector.parent).find(this.options.selector.descriptionHolder);
                this.calcDescription(index);
                this.setDescription(index,0);
                this.oFlickity[index].flickity.on('settle', _.partial(function(_this, index, event, pointer, cellElement, cellIndex) {
                    _this.setDescription(index,this.selectedIndex);
                },this,index));
                oPubsub.on(Pubsub.RESIZE,_.bind(this.calcDescription,this, index));
            }
            
            //sadly we need resize on full responsive gallery
            var bTriggerRezise;
            switch(this.oFlickity[index].$el.data(this.options.data.cnf)) {
                case 'gallery':
                    this.oFlickity[index].onresize=true;
                    this.oFlickity[index].$img=this.oFlickity[index].$el.find('img');
                    this.oFlickity[index].iImg=this.oFlickity[index].$img.length;
                    bTriggerRezise=true;
                    break;
                    
                default:
                    bTriggerRezise=false;
                    break;
            }
            
            if(true===bTriggerRezise) {
                this.setSize(index);
            } else {
                this.oFlickity[index].$el.addClass(this.options.className.activeShow);
            }

            /**
             * @ee FDZ-330: disable vertical touchmove
             * add appropriate listener
             */
            this.oFlickity[index].flickity.on('dragStart', _.bind(this.disableTouchMove, this));
            this.oFlickity[index].flickity.on('dragEnd', _.bind(this.enableTouchMove, this));
            this.oFlickity[index].$el.on('touchmove', _.bind(this.onTouchmove, this));

            /**
             * @jira FDZ-619
             * add listener for set source on gallery
             */
            switch(this.oFlickity[index].$el.data(this.options.data.cnf)) {
                case 'gallery':
                    this.oFlickity[index].setSourceOnresize = true;
                    this.oFlickity[index].count = this.oFlickity[index].flickity.cells.length;
                    this.setSource(index,0);
                    this.oFlickity[index].flickity.on('settle', _.partial(function(_this, index) {
                        _this.setSource(index,this.selectedIndex);
                    },this,index));
                    break;
                
                default:break;
            }
        };
        
        /**
         * resize flickity for given index
         * 
         * @param {int} index
         * @returns {undefined}
         */
        this.resizeFlickity=function(index)
        {
            if(
                    (undefined!==this.oFlickity[index])
                    && (true===Cnf.isMobile)
            ) {
                this.oFlickity[index].flickity.resize();
            }
        };
        
        /**
         * destroy flickity for given index
         * 
         * @param {int} index
         * @returns {undefined}
         */
        this.destroyFlickity=function(index)
        {
            if(undefined!==this.oFlickity[index]) {
                this.oFlickity[index].flickity.destroy();
                var $reinject=$(this.oFlickity[index].reinject);
                this.oFlickity[index].$el.append($reinject);
                this.oFlickity[index].$reinject=$reinject;
            }
        };
        
        /**
         * callback on pubsub viewport change
         * 
         * @param {type} ev
         * @returns {undefined}
         */
        this.onViewportChange=function(ev)
        {
            switch(true) {
                case ev.current==='mobile':
                    //trigger flickity on appropriate items
                    var oFlickity=_.filter(this.oFlickity, function(oItem) {
                        return oItem.viewport.indexOf('mobile')>=0;
                    });
                    
                    if(oFlickity.length>0) {
                        _.each(oFlickity, _.bind(function(oItem) {
                            this.setFlickity(oItem.index);
                        },this));
                    }
                    break;
                    
                case ev.previous==='mobile':
                    //remove flickity for appropriate items
                    var oFlickity=_.filter(this.oFlickity, function(oItem) {
                        return oItem.viewport.indexOf('mobile')>=0;
                    });
                    
                    if(oFlickity.length>0) {
                        _.each(oFlickity, _.bind(function(oItem) {
                            this.destroyFlickity(oItem.index);
                        },this));
                    }
                    break;
            }
        };
        
        this.onStaticClick=function(event, pointer, cellElement, cellIndex)
        {
            if((this.customHandle!==undefined) && this.customHandle[cellIndex]) {
                oPubsub.trigger(Pubsub.DEEPLINK_GOTO, this.customHandle[cellIndex]);
            }
            
            //trigger general pubsub event
            var item=_.find(cellElement.attributes, function(attribute, index, attributes){
                return attributes[index].nodeName===Cnf.dataFlickityCallback;
            });
            
            if(undefined!==item) {
                oPubsub.trigger(Pubsub.FLICKITY_STATICCLICK, {
                    name:item.nodeName,
                    value:item.nodeValue,
                    index:cellIndex,
                    attributes:function(){
                        var oReturn={};
                        _.each(cellElement.attributes, _.partial(function(oReturn, value, key, list){
                            oReturn[list[key].nodeName]=list[key].nodeValue;
                        }, oReturn));
                        
                        return oReturn;
                    }()
                });
            }
        };
        
        this.calcDescription=function(index)
        {
            var iHeight=0;
            _.each(this.oFlickity[index].$description, function(item) {
                iHeight=Math.max(iHeight, item.offsetHeight);
            });
            
            this.oFlickity[index].$descriptionHolder.height(iHeight + 20);
        };
        
        this.setDescription=function(index,count)
        {
            this.oFlickity[index].$descriptionHolder.html(this.oFlickity[index].$description.eq(count).html());
        };
        
        /**
         * callback on resize
         * 
         * @returns {undefined}
         */
        this.onResize=function()
        {
            _.each(this.oFlickity, _.bind(function(item) {
                if(true===item.onresize) {
                    this.setSize(item.index);
                }

                if(true === item.setSourceOnresize) {
                    this.setSource(item.index, item.flickity.selectedIndex);
                }
            }, this));
        };
        
        /**
         * set size for given gallery index
         * 
         * @jira FDZ-619
         * @updated 2023-01-19
         * @author sh@sopg.de
         * 
         * @param {type} index
         * @returns {undefined}
         */
        this.setSize=function(index)
        {
            var iHeight = this.oFlickity[index].$el.height();

            $.when(ImgPreload(this.oFlickity[index].$img))
            
                    .then(_.bind(function(index) {
                        var $deferred=new $.Deferred,
                            iWidth,
                            $el,
                            iImg=this.oFlickity[index].iImg,
                            iDone=0,
                            resolve=function(){
                                iDone++;
                                if(iDone>=iImg) {
                                    $deferred.resolve();
                                }
                            };
                        
                        this.oFlickity[index].$img.each(function() {
                            $el = $(this);

                            //set width
                            switch(Cnf.viewport) {
                                case 'mobile':
                                    $el.css({
                                        width: $el.data('mobile').ratio * iHeight
                                    });
                                    break;
                                    
                                case 'desktop':
                                case 'tablet':
                                default:
                                    $el.css({
                                        width: $el.data('desktop').ratio * iHeight
                                    });
                                    break;
                            }
                            resolve();
                        });
                        
                        return $deferred.promise();
                    }, this, index))
                    
                    .then(_.bind(function(index) {
                        this.oFlickity[index].flickity.resize();
                        this.oFlickity[index].$el.addClass(this.options.className.activeShow);
                    },this,index));
            
        };
        
        this.updateFlickityById=function(ev)
        {
            this.setElement(this.oFlickity[ev.id].$el);
        };
        
        this.destroyFlickityById=function(ev)
        {
            if(typeof this.oFlickity[ev.id].flickity!=='undefined') {
                this.oFlickity[ev.id].flickity.destroy();
            }
        };

        /**
         * callback on event touchmove
         * 
         * @see FDZ-330
         * @created 2020-03-12
         */
        this.onTouchmove = function(ev)
        {
            if(true === this.disableTouchmove)
            {
                ev.preventDefault();
            }
        };


        /**
         * enable marker disableTouchmove
         * 
         * @see FDZ-330
         * @created 2020-03-12
         */
        this.disableTouchMove = function()
        {
            this.disableTouchmove = true;
        };


        /**
         * disable marker disableTouchmove
         * 
         * @see FDZ-330
         * @created 2020-03-12
         */
        this.enableTouchMove = function()
        {
            this.disableTouchmove = false;
        };

        /**
         * set source dependend of viewport
         * 
         * @jira FDZ-619
         * @date 2023-01-19
         * @author sh@sopg.de
         * 
         * @param {int} index 
         * @param {int} count 
         */
        this.setSource = function(index, count)
        {
            var iNext = (count +1) >= this.oFlickity[index].count ? 0 : (count +1),
                iNext2 = (iNext +1) >= this.oFlickity[index].count ? 0 : (iNext +1),
                iNext3 = (iNext2 +1) >= this.oFlickity[index].count ? 0 : (iNext2 +1),
                iPrev = count <= 0 ? (this.oFlickity[index].count -1) : (count -1);

            switch(Cnf.viewport) {
                case 'mobile':
                    //set source on current
                    if(this.oFlickity[index].$img.eq(count).data('setsrc') !== 'mobile') {
                        this.oFlickity[index].$img.eq(count).data('setsrc', 'mobile');
                        this.oFlickity[index].$img.eq(count).attr('src', this.oFlickity[index].$img.eq(count).data('mobile').src);
                    }
                    
                    //preload next
                    if(this.oFlickity[index].$img.eq(iNext).data('setsrc') !== 'mobile') {
                        this.oFlickity[index].$img.eq(iNext).data('setsrc', 'mobile');
                        this.oFlickity[index].$img.eq(iNext).attr('src', this.oFlickity[index].$img.eq(iNext).data('mobile').src);
                    }
                    
                    //preload next2
                    if(this.oFlickity[index].$img.eq(iNext2).data('setsrc') !== 'mobile') {
                        this.oFlickity[index].$img.eq(iNext2).data('setsrc', 'mobile');
                        this.oFlickity[index].$img.eq(iNext2).attr('src', this.oFlickity[index].$img.eq(iNext2).data('mobile').src);
                    }
                    
                    //preload next3
                    if(this.oFlickity[index].$img.eq(iNext3).data('setsrc') !== 'mobile') {
                        this.oFlickity[index].$img.eq(iNext3).data('setsrc', 'mobile');
                        this.oFlickity[index].$img.eq(iNext3).attr('src', this.oFlickity[index].$img.eq(iNext3).data('mobile').src);
                    }
                    
                    //preload previous
                    if(this.oFlickity[index].$img.eq(iPrev).data('setsrc') !== 'mobile') {
                        this.oFlickity[index].$img.eq(iPrev).data('setsrc', 'mobile');
                        this.oFlickity[index].$img.eq(iPrev).attr('src', this.oFlickity[index].$img.eq(iPrev).data('mobile').src);
                    }
                    break;
                    
                case 'desktop':
                case 'tablet':
                default:
                    //set source on current
                    if(this.oFlickity[index].$img.eq(count).data('setsrc') !== 'desktop') {
                        this.oFlickity[index].$img.eq(count).data('setsrc', 'desktop');
                        this.oFlickity[index].$img.eq(count).attr('src', this.oFlickity[index].$img.eq(count).data('desktop').src);
                    }
                    
                    //preload next
                    if(this.oFlickity[index].$img.eq(iNext).data('setsrc') !== 'desktop') {
                        this.oFlickity[index].$img.eq(iNext).data('setsrc', 'desktop');
                        this.oFlickity[index].$img.eq(iNext).attr('src', this.oFlickity[index].$img.eq(iNext).data('desktop').src);
                    }
                    
                    //preload next2
                    if(this.oFlickity[index].$img.eq(iNext2).data('setsrc') !== 'desktop') {
                        this.oFlickity[index].$img.eq(iNext2).data('setsrc', 'desktop');
                        this.oFlickity[index].$img.eq(iNext2).attr('src', this.oFlickity[index].$img.eq(iNext2).data('desktop').src);
                    }
                    
                    //preload next3
                    if(this.oFlickity[index].$img.eq(iNext3).data('setsrc') !== 'desktop') {
                        this.oFlickity[index].$img.eq(iNext3).data('setsrc', 'desktop');
                        this.oFlickity[index].$img.eq(iNext3).attr('src', this.oFlickity[index].$img.eq(iNext3).data('desktop').src);
                    }
                    
                    //preload previous
                    if(this.oFlickity[index].$img.eq(iPrev).data('setsrc') !== 'desktop') {
                        this.oFlickity[index].$img.eq(iPrev).data('setsrc', 'desktop');
                        this.oFlickity[index].$img.eq(iPrev).attr('src', this.oFlickity[index].$img.eq(iPrev).data('desktop').src);
                    }
                    break;
            }
        };

        this.init();
    };
});
